const actions = {
  SET_USER: "SET_USER",
  SET_ROLE: "SET_ROLE",
  SET_BID: "SET_BID",
  SET_MID: "SET_MID",
};

export default actions;
